import type { RequestPayload } from "@inertiajs/core";
import { router } from "@inertiajs/react";
import { ChangeReportConfigAlert } from "../../../components/reportConfig/ChangeReportConfigAlert";
import { CertificateConfigForm } from "../../../components/reportConfig/form/CertificateConfigForm";
import { useYearContext } from "../../../hooks/useYearContext";
import { ContentShell } from "../../../layout/ContentShell";
import { ReportType } from "../../../models/enums/reportType";
import type { Group } from "../../../models/group";
import type { CertificateConfiguration } from "../../../models/reportConfigs/certificateConfiguration";
import type { Signature } from "../../../models/signature";
import type { YearContext } from "../../../models/yearContext";
import { report_configuration_path, report_configurations_path } from "../../../routes";

type CertificateConfigEditProps = {
  certificate_config: CertificateConfiguration;
  year_contexts: YearContext[];
  groups: Group[];
  has_reports: boolean;
  signatures: Signature[];
};

export default function CertificateReportEdit({
  year_contexts,
  groups,
  certificate_config,
  has_reports,
  signatures,
}: CertificateConfigEditProps) {
  const { pathWithYearContext } = useYearContext();
  const onSubmit = (values: RequestPayload) => router.patch(pathWithYearContext(report_configuration_path, certificate_config.id), values);

  return (
    <ContentShell
      title={`Zertifikat-Vorlage ${certificate_config.title}`}
      onBack={() => router.get(pathWithYearContext(report_configurations_path))}
    >
      <CertificateConfigForm
        alert={has_reports && <ChangeReportConfigAlert />}
        certificateConfig={certificate_config}
        yearContexts={year_contexts}
        groups={groups}
        saveButtonLabel="Speichern"
        onSubmit={onSubmit}
        reportType={ReportType.CERT}
        signatures={signatures}
      />
    </ContentShell>
  );
}
